import { removeBottomSheet } from './removeBottomSheet';

/**
 * Hide the bottomsheet component and remove the corresponding div from the DOM tree.
 * When ref is provided, this is equivalent to calling bottomSheetRef?.current?.close().
 * If the ref is not present, the DOM nodes are force-removed immediately.
 *
 * See: Use cleanBottomSheet if you want to force-remove the DOM nodes immediately.
 */
export function hideBottomSheet(ref?: React.RefObject<any>): void {
    /**
     * showBottomSheet adds an onUnmounted callback to the bottomsheet such that the DOM
     * nodes get purged once the transition has complete. So we are not explicitly unmounting
     * the nodes here if we have a ref.
     */
    ref?.current ? ref.current.close() : removeBottomSheet();
}

export default hideBottomSheet;
